import React from 'react';
import { TitlePane } from '../../atoms/TitlePane';
import styled from '@emotion/styled';

const Frame = styled.div({
    backgroundColor: '#E9EEF4',
    height: '100%',
});

const Message = styled.h3({
    margin: '4px',
    marginLeft: '1em',
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: 1.1,
    color: '#333',
});

export const NotFound = () => {
    return (
        <Frame>
            <TitlePane title={'ERROR'} />
            <Message>{'404 Page Not Found...'}</Message>
        </Frame>
    );
};
